import { useLocation, useNavigate } from 'react-router-dom';
import { MessageSquare, Hash, Phone, Settings } from 'lucide-react';
import { useMobile } from '@/pages/chat/ChatPage';

/**
 * Bottom tab bar for mobile / iPhone PWA.
 * Mimics the Android native app navigation.
 * Hidden on desktop (md:hidden).
 */
export default function MobileBottomNav() {
  const navigate = useNavigate();
  const location = useLocation();
  const { setShowSidebar } = useMobile();

  const path = location.pathname;

  const tabs = [
    { id: 'channels', icon: Hash, label: 'Каналы', match: ['/', '/channel'] },
    { id: 'dm', icon: MessageSquare, label: 'Чаты', match: ['/dm'] },
    { id: 'calls', icon: Phone, label: 'Звонки', match: ['/calls'] },
    { id: 'settings', icon: Settings, label: 'Ещё', match: ['/settings', '/library', '/bots', '/miniapps'] },
  ] as const;

  const activeTab = tabs.find(t =>
    t.match.some(m => m === '/' ? path === '/' : path.startsWith(m))
  )?.id ?? 'channels';

  const handleTab = (tabId: string) => {
    switch (tabId) {
      case 'channels':
        setShowSidebar(true);
        navigate('/');
        break;
      case 'dm':
        setShowSidebar(false);
        navigate('/dm');
        break;
      case 'calls':
        setShowSidebar(false);
        navigate('/calls');
        break;
      case 'settings':
        setShowSidebar(false);
        navigate('/settings');
        break;
    }
  };

  return (
    <nav className="md:hidden flex-shrink-0 border-t border-surface-800 bg-surface-900 flex"
         style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}>
      {tabs.map((tab) => {
        const Icon = tab.icon;
        const isActive = activeTab === tab.id;
        return (
          <button
            key={tab.id}
            onClick={() => handleTab(tab.id)}
            className={`flex-1 flex flex-col items-center justify-center py-2 transition-colors ${
              isActive ? 'text-brand-400' : 'text-surface-500'
            }`}
          >
            <Icon size={20} />
            <span className="text-[10px] mt-0.5">{tab.label}</span>
          </button>
        );
      })}
    </nav>
  );
}
